module.exports = __webpack_public_path__ + "ae0f3ae1f6ab5226b56726616c408999.pdf";